import { render, staticRenderFns } from "./Management-notice.vue?vue&type=template&id=1b1553b0&scoped=true&"
import script from "./Management-notice.vue?vue&type=script&lang=js&"
export * from "./Management-notice.vue?vue&type=script&lang=js&"
import style0 from "./Management-notice.vue?vue&type=style&index=0&id=1b1553b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1553b0",
  null
  
)

export default component.exports